import {
  Button,
  Grid,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import { WASHUB_CONSTANTS } from '../../shared/Constants';
import { useAPI } from '../../shared/services/api/API';
import { IBusinessStore } from '../../shared/models/business.model';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

export const GarmentSummaryNote = () => {
  const { axiosInstance, httpGet, handleAlertBar } = useAPI();
  const [storeList, setStoreList] = useState<IBusinessStore[]>([]);
  const [deptList, setDeptList] = useState([]);
  const end = new Date();
  const tomorrowDate = end.setDate(end.getDate() + 1);
  const [deliveryDate, setDeliveryDate] = useState(dayjs(tomorrowDate));
  const [formData, setFormData] = useState({
    departmentId: '',
    businessId: '',
    businessStoreId: '',
    deliveryDate: deliveryDate,
    deliveryTime: '00:00:00',
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isEmailLoading, setIsEmailLoading] = useState<boolean>(false);
  const queryParams = {
    page: 0,
    size: 10000,
    sortColumn: 'modifiedAt',
  };
  const timeList: string[] = [
    '00:00:00',
    '1:00:00',
    '2:00:00',
    '3:00:00',
    '4:00:00',
    '5:00:00',
    '6:00:00',
    '7:00:00',
    '8:00:00',
    '9:00:00',
    '10:00:00',
    '11:00:00',
    '12:00:00',
    '13:00:00',
    '14:00:00',
    '15:00:00',
    '16:00:00',
    '17:00:00',
    '18:00:00',
    '19:00:00',
    '20:00:00',
    '21:00:00',
    '22:00:00',
    '23:00:00',
  ];

  const handleDeliveyDateChange = (date: any) => {
    setDeliveryDate(date);
    setFormData((prevData) => ({
      ...prevData,
      ['deliveryDate']: date,
    }));
  };

  // GET with API : Business store list
  const fetchBusinessStore = async () => {
    httpGet(
      WASHUB_CONSTANTS.API_URLS.BUSINESS_STORE_ADMIN_BUSINESS_DATA_GET,
    ).then((response) => {
      if (response.status === 200) {
        const sortBusinessStoreArray = response?.data?.sort((a: any, b: any) =>
          a?.name.toLowerCase().localeCompare(b.name.toLowerCase()),
        );
        setStoreList(sortBusinessStoreArray);
      } else {
        if (response.data.error) {
          console.error(
            'Error fetching BusinessStore: ',
            response.data.message,
          );
        }
      }
    });
  };

  // GET with API : Department list
  const fetchBusinessStoreDepartmentData = async (businessStoreId: string) => {
    await httpGet(
      `${WASHUB_CONSTANTS.API_URLS.BUSINESSSTORE_DEPARTMENT_DATA_GET}/${businessStoreId}`,
      queryParams,
    ).then((response) => {
      if (response.status === 200) {
        const sortBusinessDeptArray = response?.data?.sort((a: any, b: any) =>
          a?.name.toLowerCase().localeCompare(b.name.toLowerCase()),
        );
        setDeptList(sortBusinessDeptArray);
      } else {
        if (response.data.error) {
          console.error(
            'Error fetching Business Store Department: ',
            response.data.message,
          );
        }
      }
    });
  };

  // Post with API: Print Garment summary report
  const printGarmentSummaryReport = async () => {
    setIsLoading(true);
    const payload = {
      departmentId: formData.departmentId,
      businessId: formData.businessId,
      businessStoreId: formData.businessStoreId,
      deliveryDate: formData.deliveryDate.format('YYYY-MM-DD'),
      deliveryTime: formData.deliveryTime,
    };
    axiosInstance
      .post(
        WASHUB_CONSTANTS.API_URLS.GARMENT_SUMMARY_NOTE_PRINT_POST,
        payload,
        {
          headers: {
            Authorization: localStorage.getItem('jwtToken') || null,
          },
          responseType: 'blob',
        },
      )
      .then((response: any) => {
        if (response?.status === 200) {
          const blob = new Blob([response.data], { type: 'application/pdf' });
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          const contentDisposition = response.headers['content-disposition'];
          let fileName = `Garment-summary-note-${formData.departmentId}-${formData.deliveryDate}`;
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/);
            if (fileNameMatch.length === 2) fileName = fileNameMatch[1];
          }
          console.log(contentDisposition);
          a.setAttribute('download', fileName);
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
        } else {
          if (response?.data?.error) {
            handleAlertBar("error", `No Garment Delivery  Items for  ${formData.deliveryDate.format('YYYY-MM-DD')} and  ${formData.deliveryTime}`);
          }
        }
        setIsLoading(false);
      })
      .catch((err) => {
        handleAlertBar("error", `No Garment Delivery  Items for  ${formData.deliveryDate.format('YYYY-MM-DD')} and  ${formData.deliveryTime}`);
        setIsLoading(false);
      });
  };

  // POST with API : Generate delivery Notes
  const fetchEmailGarmentSummaryReport = async () => {
    setIsEmailLoading(true);
    const payload = {
      departmentId: formData.departmentId,
      businessId: formData.businessId,
      businessStoreId: formData.businessStoreId,
      deliveryDate: formData.deliveryDate.format('YYYY-MM-DD'),
      deliveryTime: formData.deliveryTime,
    };
    axiosInstance
      .post(
        WASHUB_CONSTANTS.API_URLS.GARMENT_SUMMARY_NOTE_EMAIL_POST,
        payload,
        {
          headers: {
            Authorization: localStorage.getItem('jwtToken') || null,
          },
          responseType: 'blob',
        },
      )
      .then((response: any) => {
        if (response?.status === 200) {
          handleAlertBar(
            'success',
            'Garment summary note has been sent to your email',
          );
        } else {
          if (response?.data?.error) {
            console.error(
              'Error fetching BusinessStoreInvoices: ',
              response?.data?.message,
            );
          }
        }
        setIsEmailLoading(false);
      })
      .catch((err) => {
        console.log('Second catch');
        setIsEmailLoading(false);
      });
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    console.log(name, value);
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    if (name === 'businessStoreId') {
      const data: any = storeList.filter((store: any) => store.id === value);
      console.log(data);
      setFormData((prevData) => ({
        ...prevData,
        ['businessId']: data[0].business.id,
      }));
    }
  };

  useEffect(() => {
    fetchBusinessStore();
  }, []);

  useEffect(() => {
    if (formData.businessStoreId) {
      fetchBusinessStoreDepartmentData(formData.businessStoreId);
    }
  }, [formData.businessStoreId]);

  return (
    <div style={{ width: '100%', overflow: 'hidden' }}>
      <Grid container>
        <Grid item className="mb-1 mt-1 ms-3">
          <Typography
            sx={{ textAlign: 'center' }}
            variant="h5"
            className="mt-0"
          >
            Garment Summary Note
          </Typography>
        </Grid>
      </Grid>
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          width: '100%',
          padding: '2px 15px',
          minWidth: { xs: '300px', sm: '360px', md: '400px' },
          gap: '1rem',
        }}
      >
        <TextField
          size="small"
          key="businessStoreId"
          style={{ width: '30%' }}
          label="Select Business Store"
          name="businessStoreId"
          select
          onChange={handleInputChange}
          value={formData.businessStoreId}
        >
          {storeList.map((option: any) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
        <TextField
          size="small"
          style={{ width: '30%' }}
          key="departmentId"
          label="Select Department"
          name="departmentId"
          select
          onChange={handleInputChange}
          value={formData.departmentId}
          disabled={formData.businessStoreId === ''}
        >
          {deptList.map((option: any) => (
            <MenuItem key={option.id} value={option.id}>
              {option.name}
            </MenuItem>
          ))}
        </TextField>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label={'Delivery date'}
            slotProps={{ textField: { size: 'small' } }}
            name="deliveryDate"
            value={dayjs(deliveryDate)}
            onChange={handleDeliveyDateChange}
            sx={{ width: '30%' }}
          />
        </LocalizationProvider>
        <TextField
          size="small"
          style={{ width: '30%' }}
          key="deliveryTime"
          label="Select Delivery time"
          name="deliveryTime"
          select
          onChange={handleInputChange}
          value={formData.deliveryTime}
        >
          {timeList.map((option: any) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
      </Stack>
      <Stack
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'flex-end',
          justifyContent: 'flex-end',
          width: '100%',
          padding: '8px 15px',
          minWidth: { xs: '300px', sm: '360px', md: '400px' },
          gap: '1rem',
        }}
      >
        <div className="d-flex gap-3">
          <Button
            color="primary"
            sx={{ color: 'white' }}
            variant="contained"
            disabled={isLoading}
            onClick={() => printGarmentSummaryReport()}
          >
            Print Garment Summary report
          </Button>
          <Button
            color="primary"
            sx={{ color: 'white' }}
            variant="contained"
            disabled={isEmailLoading}
            onClick={() => fetchEmailGarmentSummaryReport()}
          >
            Email Garment Summary report
          </Button>
        </div>
      </Stack>
    </div>
  );
};
